// extracted by mini-css-extract-plugin
export default {"root":"Placeholder_root__pzkT9"};